export default __webpack_public_path__ + "static/media/SPPL_Fiscal_2024.4fd29d89.pdf";